import type { HelpFile } from '../../types/help'
import { RestrictionRuleRequestCreateWizardTestIds } from '../../../testids/RestrictionRuleRequestCreateWizardTestIds'

export const restrictionRuleRequestCreateWizardHelp: HelpFile = {
  docPage: '/docs/governance/restriction-rule-requests',
  texts: {
    [RestrictionRuleRequestCreateWizardTestIds.inputName]:
      'Eindeutiger Name für diese Restriktionsregel — identifiziert den Antrag im Genehmigungsworkflow.',
    [RestrictionRuleRequestCreateWizardTestIds.graceDaysPicker]:
      'Tage bis zur Bereinigung von Verstößen nach Deaktivierung — gibt betroffenen Identitäten Zeit, verwehrte Profile zu entfernen.',
    [RestrictionRuleRequestCreateWizardTestIds.inputConditionExpr]:
      'CEL-Ausdruck, der bestimmt, für welche Identitäten diese Regel gilt.',
    [RestrictionRuleRequestCreateWizardTestIds.btnToggleHelp]:
      'CEL-Syntaxhilfe ein- oder ausblenden.',
    [RestrictionRuleRequestCreateWizardTestIds.btnRunTest]:
      'Bedingung gegen alle aktuellen Identitäten ausführen — zeigt Treffer und Verstöße.',
    [RestrictionRuleRequestCreateWizardTestIds.testResultsSuccess]:
      'Testlauf-Zusammenfassung — ausgewertete, treffende und verstoßende Identitäten.',
    [RestrictionRuleRequestCreateWizardTestIds.profileModeToggle]:
      'Zwischen Profilauswahl per Liste und per Bedingungsausdruck wechseln.',
    [RestrictionRuleRequestCreateWizardTestIds.inputProfileSearch]:
      'Zugriffsprofile für die verbotene Liste suchen.',
    [RestrictionRuleRequestCreateWizardTestIds.inputProfileCondition]:
      'CEL-Ausdruck, der zu verwehrende Zugriffsprofile auswählt — Identitäten mit einem Treffer gelten als Verstoß.',
    [RestrictionRuleRequestCreateWizardTestIds.reviewTestSummary]:
      'Zusammenfassung des letzten Testlaufs gegen aktuelle Identitäten.',
    [RestrictionRuleRequestCreateWizardTestIds.btnSubmit]:
      'Zur Genehmigung einreichen — nach dem Einreichen nicht mehr bearbeitbar.',
    [RestrictionRuleRequestCreateWizardTestIds.btnSkipTest]:
      'Test überspringen — der Antrag kann ohne Test eingereicht werden, Reviewer sehen dann „nicht getestet".',
    [RestrictionRuleRequestCreateWizardTestIds.btnAbandonConfirm]:
      'Entwurf verwerfen und Assistenten verlassen — nicht gespeicherte Änderungen gehen verloren.',
    [RestrictionRuleRequestCreateWizardTestIds.btnAbandonStay]:
      'Im Assistenten bleiben und weiter bearbeiten.',
    [RestrictionRuleRequestCreateWizardTestIds.abandonDialogTitle]:
      'Bestätigung, ob der Entwurf verworfen werden soll.',
    [RestrictionRuleRequestCreateWizardTestIds.conditionEmptyWarning]:
      'Keine Identitätsbedingung gesetzt — die Regel gilt für alle Identitäten.',
    [RestrictionRuleRequestCreateWizardTestIds.noProfilesSelected]:
      'Noch keine verbotenen Profile ausgewählt — mindestens ein Profil oder eine Profilbedingung erforderlich.',
    [RestrictionRuleRequestCreateWizardTestIds.notTestedNote]:
      'Vor Einreichung nicht getestet — Genehmigende können trotzdem zustimmen, die Auswirkungen sind jedoch unbekannt.',
    [RestrictionRuleRequestCreateWizardTestIds.selectedProfilesList]:
      'Aktuell durch diese Regel verbotene Zugriffsprofile — Identitäten mit einem dieser Profile verstoßen gegen die Regel.',
    [RestrictionRuleRequestCreateWizardTestIds.inputDescription]: null,
    [RestrictionRuleRequestCreateWizardTestIds.btnPreviousStep]: null,
    [RestrictionRuleRequestCreateWizardTestIds.btnNextStep]: null,
    [RestrictionRuleRequestCreateWizardTestIds.errorName]: null,
    [RestrictionRuleRequestCreateWizardTestIds.errorOwner]: null,
    [RestrictionRuleRequestCreateWizardTestIds.btnProfileModeCondition]: null,
    [RestrictionRuleRequestCreateWizardTestIds.btnProfileModeList]: null,
    [RestrictionRuleRequestCreateWizardTestIds.btnViewAffected]: null,
    [RestrictionRuleRequestCreateWizardTestIds.expressionValidating]:
      'Der CEL-Ausdruck wird von der In-Browser-CEL-Engine validiert.',
    [RestrictionRuleRequestCreateWizardTestIds.expressionValidIndicator]:
      'Der CEL-Ausdruck ist syntaktisch gültig.',
    [RestrictionRuleRequestCreateWizardTestIds.expressionInvalidIndicator]:
      'Der CEL-Ausdruck enthält Parse-Fehler. Die Zeilen-/Spaltenangabe verweist auf den ersten Fehler.',
    [RestrictionRuleRequestCreateWizardTestIds.expressionNetworkError]:
      'Die Validierung ist fehlgeschlagen, weil das Backend nicht erreichbar war. Der Ausdruck selbst kann trotzdem gültig sein — beim Absenden wird erneut validiert.',
    [RestrictionRuleRequestCreateWizardTestIds.pageRestrictionRuleRequestCreateWizard]: null,
    [RestrictionRuleRequestCreateWizardTestIds.restrictionRuleRequestStepContainer]: null,
    [RestrictionRuleRequestCreateWizardTestIds.thTestResultIdentity]: null,
    [RestrictionRuleRequestCreateWizardTestIds.thTestResultOwner]: null,
  },
}
